import { Paragraph } from "../../../../components/atoms";
import { OtpEntry } from "../../../../components/molecules/login-registration-group/otp";
import {
  ILoginUser,
  validatePhoneOtp,
} from "../../../../services/api/customer";
import { ApiError } from "../../../../services/error-handler";
import { theme } from "../../../../theme";
import * as React from "react";
import { Helmet } from "react-helmet";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

const ErrorParagraph = Paragraph.extend`
  color: ${theme.color.error};
`;

const LinksParagraph = Paragraph.extend`
  margin-top: 24px;
  text-align: center;

  a {
    color: ${theme.color.ruubyGrey};
  }
`;

interface IOwnProps {
  loggedOutRoute: string;
  onLogIn(user: ILoginUser): void;
}

interface IRouteParams {
  otpRequestId: string;
  phoneNumber: string;
  phoneCodeIndex: string;
}

interface IState {
  errorMessage?: string;
}

type IProps = IOwnProps & RouteComponentProps<IRouteParams>;

class LoginPhoneValidateOtpComponent extends React.PureComponent<
  IProps,
  IState
> {
  private otpEntry?: OtpEntry;

  public state: IState = {
    errorMessage: undefined,
  };

  /**
   * Submit the OTP to the server
   * @param code OTP code entered
   */
  private readonly handleCompleteOtp = async (code: string) => {
    try {
      const user = await validatePhoneOtp(
        this.props.match.params.otpRequestId,
        code,
      );

      // all ok! set logged in
      this.props.onLogIn(user);
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.code === "LOGIN_OTP_CUSTOMER_NOT_FOUND") {
          this.props.history.replace(`${this.props.loggedOutRoute}/register`, {
            otpCode: code,
            otpRequestId: this.props.match.params.otpRequestId,
            phoneCodeIndex: this.props.match.params.phoneCodeIndex,
            phoneNumber: this.props.match.params.phoneNumber,
          });
        } else {
          this.setState({ errorMessage: err.message });
          if (this.otpEntry) {
            this.otpEntry.reset();
          }
        }
      }
    }
  };

  // tslint:disable-next-line: completed-docs
  public render(): JSX.Element {
    const error =
      typeof this.state.errorMessage !== "undefined" ? (
        <ErrorParagraph>{this.state.errorMessage}</ErrorParagraph>
      ) : undefined;

    return (
      <React.Fragment>
        <Helmet>
          <title>Ruuby - Checkout - Enter SMS code</title>
        </Helmet>
        <Paragraph>
          We just sent a code to your phone. Please enter it below to continue.
        </Paragraph>
        <OtpEntry
          ref={(ref) => {
            if (ref) {
              this.otpEntry = ref;
            }
          }}
          onComplete={this.handleCompleteOtp}
          invalid={typeof this.state.errorMessage !== "undefined"}
        />
        {error}

        <LinksParagraph>
          <Link to={`${this.props.loggedOutRoute}/phone`} replace>
            Use a different number
          </Link>{" "}
          |{" "}
          <Link to={`${this.props.loggedOutRoute}/email`} replace>
            Log in via email instead
          </Link>
        </LinksParagraph>
      </React.Fragment>
    );
  }
}

export const LoginPhoneValidateOtp = withRouter(LoginPhoneValidateOtpComponent);
